import * as React from 'react';
import {PluginTemplates} from "../utils/PluginTemplates";
import FalconHeader from "../components/navigation/FalconHeader";
import {FalconNavigatorHeader, resourcesHelper, Footer} from "@ferry/portal-core";

export class ComplaintsPage extends React.Component {

    private pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Complaints");
    }

    public render() {
        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="complaints-page plugin">
                    <FalconNavigatorHeader title="Complaints"/>
                    <div className="panel">
                        <div className="static-page-wrapper">
                            <h5 className="font-light">Our complaints commitment</h5>
                            <p>Once you've told us about your complaint, here's what we'll do next:</p></div>
                        <div className="static-page-wrapper">
                            <ul>
                                <li>Pass it to the right person</li>
                                <li>Get back to you as soon as possible so you know what to expect next</li>
                                <li>
                                    Give you the name and contact details of the person dealing with your complaint,
                                    deal with your complaint fairly
                                </li>
                                <li>Listen to your feedback and see what lessons we can learn from it</li>
                                <li>Give you a written update on progress in the unlikely event that you complaint
                                    is going to take more than eight weeks to resolve
                                </li>
                            </ul>
                        </div>
                        <div className="static-page-wrapper">
                            <p>Get in touch about your complaint on{' '}
                                <a className="aligned-left no-underline" href={`mailto:${resourcesHelper.COMPLAINT_EMAIL}`} target="_blank"
                                   id="complaintsEmail">{resourcesHelper.COMPLAINT_EMAIL}</a>
                            </p>
                        </div>
                        <div className="static-page-wrapper">
                            <h5>Your rights</h5>
                            <p className="padding-bottom-26">If you're not happy with how we've handled your complaint, here's what you can do
                                next:</p>
                            <p>
                                If we can't resolve your complaint, the Financial Ombudsman Service may be able to help you.
                                Their service is free for you, but you'll need to contact them within six months of
                                receiving our final response letter.
                            </p>
                        </div>
                        <div className="static-page-wrapper">
                            <h5>Websites</h5>
                            <p className="padding-bottom-26">Financial Ombudsman Service{' '}
                                <a className="no-underline" href="https://www.financial-ombudsman.org.uk" target="_blank"
                                   id="financialOmbudsmanOrg">www.financial-ombudsman.org.uk </a>
                                which includes more information about the service,
                                including details of the various ways they can be contacted.
                            </p>
                        </div>
                        <div className="static-page-wrapper">
                            <p>We're not responsible for the content of external websites.</p>
                        </div>
                    </div>
                    <div className="complaints-page-back-btn aligned-left">
                        {this.pluginTemplates.renderBackButton()}
                    </div>
                </div>
                <Footer/>
            </React.Fragment>
        )
    }
}
